export default __webpack_public_path__ + "static/bam-3004dab4c29d7f5935277300ac579204.png";